import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { FullRow, Tooltip } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { utils } from '~/utils';
import pluralize from '~/utils/pluralize';
import { invoiceStatusToColor } from './invoicesDigest.utils';
import styles from './InvoicesDigestWidget.module.scss';
import { getDigestStatusLink, invoiceTypeToTooltip } from './InvoicesDigestWIdget.utils';
export const GetInvoiceBarTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            InvoiceBarTID: {
                Root: 'invoices-bar',
                Tooltip: (type)=>"invoice-bar-".concat(type, "-percentage-tooltip"),
                Percentage: (type)=>"invoice-bar-".concat(type, "-percentage")
            }
        }
    });
const InvoiceBar = (param)=>{
    let { invoicesDigest } = param;
    const { InvoiceBarTID } = useMemo(()=>GetInvoiceBarTID(), []);
    return /*#__PURE__*/ _jsx(FullRow, {
        className: styles.invoiceBarContent,
        testId: InvoiceBarTID.Root(),
        children: invoicesDigest.percentages().map((param)=>{
            let { type, percentage, count, amount } = param;
            const linkTo = getDigestStatusLink(routes.invoicesDashboard, type);
            return /*#__PURE__*/ _jsx(Tooltip, {
                title: /*#__PURE__*/ _jsxs("div", {
                    "data-testid": InvoiceBarTID.Tooltip(type),
                    children: [
                        utils.formatNumberWithCommas(count),
                        " ",
                        pluralize('invoice', count),
                        " totaling",
                        ' ',
                        amount.display(),
                        " ",
                        invoiceTypeToTooltip(count)[type]
                    ]
                }),
                children: /*#__PURE__*/ _jsx(NavLink, {
                    style: {
                        width: "".concat(percentage, "%"),
                        backgroundColor: invoiceStatusToColor[type]
                    },
                    to: linkTo,
                    "data-testid": InvoiceBarTID.Percentage(type),
                    className: styles.invoiceBarPercentage
                })
            }, type);
        })
    });
};
export default InvoiceBar;
